module.exports = __webpack_public_path__ + "img/meaning.d75cac53.svg";